import React, { createContext, useContext, useEffect, useState } from 'react';
import { getFilters } from './searchService';

const FiltersContext = createContext({
  brands: [],
  sizes: [],
  genders: [],
  colors: [],
  categories: [],
});

export function FiltersProvider({ children }) {
  const [filters, setFilters] = useState({
    brands: [],
    sizes: [],
    genders: [],
    colors: [],
    categories: [],
  });

  useEffect(() => {
    getFilters()
      .then(setFilters)
      .catch(() => {});
  }, []);

  return (
    <FiltersContext.Provider value={filters}>
      {children}
    </FiltersContext.Provider>
  );
}

export function useFilterOptions() {
  return useContext(FiltersContext);
}
